module.exports = __webpack_public_path__ + "img/product-tutorial-4.a0e9c563.png";